import EventEmitter from '../utils/EventEmitter';
import dispatcher from '../dispatcher';

var eventEmitter = new EventEmitter();

var data = {}
var string = '';

function deserialize(query) {
	var result = {};
	var eq, key, val, from, to, index;

	var pos = query.indexOf('?');
	query = query.substr(pos + 1);

	query.split('&').forEach(function(part) {
		if (!part) return;
		part = part.split('+').join(' ');
		eq = part.indexOf('=');
		key = eq > -1 ? part.substr(0, eq) : part;
		val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : '';
		from = key.indexOf('[');
		if (from === -1) {
			result[decodeURIComponent(key)] = val;
		} else {
			to = key.indexOf(']', from);
			index = decodeURIComponent(key.substring(from + 1, to));
			key = decodeURIComponent(key.substring(0, from));
			if(!result[key]) result[key] = {};
			if(!index) {
				result[key].push(val);
			} else {
				result[key][index] = val;
			}
		}
	});
	return result;
}

function serialize(obj, prefix) {
	var k, v;
	var str = [], p;
	for (p in obj) {
		if (obj.hasOwnProperty(p)) {
			k = prefix ? prefix + '[' + p + ']' : p;
			v = obj[p];
			str.push((v !== null && typeof v === 'object') ?
				serialize(v, k) :
				k + '=' + encodeURIComponent(v));
		}
	}
	return str.join('&');
}

var _handleEvent = function(e) {
	var parts;
	var obj;
	var wasSet = false;

	function setValue(name, value) {
		parts = name.split('.');
		if (parts.length === 1) {
			if (value === undefined || value === '') {
				delete data[name];
			} else {
				data[name] = value;
			}
		} else {
			obj = data;
			parts.forEach(function(part, index) {
				if (wasSet) return;

				if (!obj[part]) {
					obj[part] = {};
				}

				if (index === parts.length - 1) {
					if (!value) {
						delete obj[part];
						wasSet = true;
					} else {
						obj[part] = value;
					}
				}

				obj = obj[part];
			});
		}
	}

	if (e.type === 'address:set') {
		setValue(e.name, e.value);

		string = serialize(data);

		if (!e.hasOwnProperty('history') || e.history === true) {
			history.replaceState({}, '', '?' + string);
		}
	}

	if (e.type === 'address:remove') {
		setValue(e.name, undefined);

		string = serialize(data);

		if (!e.hasOwnProperty('history') || e.history === true) {
			history.replaceState({}, '', '?' + string);
		}
	}

	if (e.type === 'content:before-replaced') {
		string = location.search;
		data = deserialize(location.search);
		eventEmitter.dispatch();
	}
}

var getData = function() {
	return {
		data: data,
		string: string,
		href: location.protocol + '//' + location.host + location.pathname + '?' + string,
	};
}

var _init = function() {
	dispatcher.subscribe(_handleEvent);
	string = location.search;
	data = deserialize(location.search);

	eventEmitter.dispatch();
}

_init();

export default {
	subscribe: eventEmitter.subscribe.bind(eventEmitter),
	unsubscribe: eventEmitter.unsubscribe.bind(eventEmitter),
	getData: getData
}